import type {
  SiteComponentImport,
  SiteComponentImportAccess,
} from "schemas/generated/siteComponentImport";
import type { RequestFn } from "./request";

export function createSiteComponentImportsClient({
  request,
}: {
  request: RequestFn;
}) {
  const importsPath = (projectId: string) => {
    return `/api/v1/projects/${encodeURIComponent(projectId)}/site-component-imports`;
  };
  return {
    access: {
      get: ({ projectId }: { projectId: string }) => {
        return request<SiteComponentImportAccess>({
          method: "GET",
          path: `${importsPath(projectId)}/access`,
        });
      },
    },
    /** Starts importing the source site into the site, or returns the import already running there. */
    create: ({
      projectId,
      siteId,
      url,
      retryNames,
    }: {
      projectId: string;
      siteId: string;
      url: string;
      retryNames: string[] | null;
    }) => {
      return request<SiteComponentImport>({
        method: "POST",
        path: importsPath(projectId),
        body: { siteId, url, retryNames },
      });
    },
    latest: {
      get: ({ projectId, siteId }: { projectId: string; siteId: string }) => {
        return request<SiteComponentImport | null>({
          method: "GET",
          path: `${importsPath(projectId)}/latest?siteId=${encodeURIComponent(siteId)}`,
        });
      },
    },
    stop: ({
      projectId,
      importId,
    }: {
      projectId: string;
      importId: string;
    }) => {
      return request<SiteComponentImport>({
        method: "POST",
        path: `${importsPath(projectId)}/${encodeURIComponent(importId)}/stop`,
      });
    },
  };
}
